import Vue from 'vue'
import Vuex from 'vuex'

import appModule from './modules/app'
import adminModule from './modules/admin'
import authModule from './modules/auth'
import presentersModule from './modules/presenters'
import coursesModule from './modules/courses'
import categoriesModule from './modules/categories'
import learningPathsModule from './modules/learning-paths'
import searchModule from './modules/search'
import userModule from './modules/user'
import contentModule from './modules/content'
import quizzesModule from './modules/quizzes'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app: appModule,
    admin: adminModule,
    auth: authModule,
    courses: coursesModule,
    categories: categoriesModule,
    learningPaths: learningPathsModule,
    presenters: presentersModule,
    search: searchModule,
    user: userModule,
    content: contentModule,
    quizzes: quizzesModule,
  },
})

export default store
